import { render, staticRenderFns } from "./suitch-valve-config-widget.vue?vue&type=template&id=f8db7392&scoped=true&"
import script from "./suitch-valve-config-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-valve-config-widget.vue?vue&type=script&lang=js&"
import style0 from "./suitch-valve-config-widget.vue?vue&type=style&index=0&id=f8db7392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8db7392",
  null
  
)

export default component.exports